import choitrang from "../assets/img/choitrang.png";
import ly12thang from "../assets/img/ly12thang.png";
import lydaucaudai from "../assets/img/lycaudai.png";
import chucnghelamruong from "../assets/img/chucnghelamruong.png";
import chucnghelamruong2 from "../assets/img/chucnghelamruong2.png";
import chucnghedetvai from "../assets/img/chucnghedetvai.png";
import vecabien from "../assets/img/vecabien.png";
import vecadong from "../assets/img/vecadong.png";
import namthubamuoi from "../assets/img/namthubamuoi.png";
import vecaomuoi from "../assets/img/vecaomuoi.png";
import a3721 from "../assets/img/3721.png";
import lythotho from "../assets/img/lythotho.png";
import vecontom from "../assets/img/vecontom.png";
import chucnghethoho from "../assets/img/chucnghethoho.png";
import chucnghethomoc from "../assets/img/chucnghethomoc.png";
import chucnghethoduong from "../assets/img/chucnghethoduong.png";
import lydaucauvan from "../assets/img/lydaucauvan.png";
import page341 from "../assets/img/pages/341.jpg" //chuc nghe lam ruong
import page342 from "../assets/img/pages/342.jpg" //chuc nghe lam ruong
import page343 from "../assets/img/pages/343.jpg" //chuc nghe tho moc
import page344 from "../assets/img/pages/344.jpg" //chuc nghe tho ho
import page345 from "../assets/img/pages/345.jpg" //chuc nghe tho ho
import page346 from "../assets/img/pages/346.jpg" //ve con ca
import page347 from "../assets/img/pages/347.jpg" //ve con ca
import page348 from "../assets/img/pages/348.jpg" //ve con ca
import page349 from "../assets/img/pages/349.jpg" //ve con ca
import page350 from "../assets/img/pages/350.jpg" //ve con ca
import page351 from "../assets/img/pages/351.jpg" //ve con ca
import page352 from "../assets/img/pages/352.jpg" //ve con ca
import page353 from "../assets/img/pages/353.jpg" //ve con ca
import page354 from "../assets/img/pages/354.jpg" //ve con ca
import page355 from "../assets/img/pages/355.jpg" //ly lo tho
import page356 from "../assets/img/pages/356.jpg" //ly lo tho
import page357 from "../assets/img/pages/356.jpg" //ly lo tho
import page358 from "../assets/img/pages/358.jpg" //ly 12 thang
import page359 from "../assets/img/pages/359.jpg" //ly 12 thang
import page360 from "../assets/img/pages/360.jpg" //ly 12 thang
import page361 from "../assets/img/pages/361.jpg" //ly 12 thang
import page362 from "../assets/img/pages/362.jpg" //ly 12 thang
import page363 from "../assets/img/pages/363.jpg" //ly 12 thang
import page364 from "../assets/img/pages/364.jpg" //ly dau cau
import page365 from "../assets/img/pages/365.jpg" //ly dau cau
import page366 from "../assets/img/pages/366.jpg" //ly dau cau
import page367 from "../assets/img/pages/367.jpg" //ly dau cau
import page368 from "../assets/img/pages/368.jpg" //ly dau cau
import page369 from "../assets/img/pages/369.jpg" //ly dau cau
import page370 from "../assets/img/pages/370.jpg" //ke chuyen chien thang phu le
import page371 from "../assets/img/pages/371.jpg" //ke chuyen chien thang phu le
import page372 from "../assets/img/pages/372.jpg" //ke chuyen chien thang phu le

const giupVuiData = [
  {
    id: 1,
    title: "Chơi Trăng",
    content: `**Cái kể**: Thuở Minh Hoàng thượng điện  
Lập quần thần lập yến chơi trăng  
Tiết Trung thu nguyệt rạng tợ đăng  
Ai ai cũng du sơn du thủy  
Các quan mừng tụ lại  
Lập cuộc phỉ chí chơi bời  
Đến đêm nay lặng gió thanh trời  
Ai ai cũng chơi trăng là đến tuyết…  
(Nghệ nhân đờn cò, trống phách gõ theo)  
**Con xô**: Chơi trăng chơi trăng  
**Cái kể**: Chúa tôi nằn nằn  
**Con xô**: Chơi trăng một hội  
**Cái kể**: Kẻ đua qua núi  
**Con xô**: Tàu nổi dưới sông  
**Cái kể**: Kẻ đua qua Đông  
**Con xô**: Người đua qua Bắc  
**Cái kể**: Mấy chỗ lầu các  
**Con xô**: Cúng cấp chào rào  
**Cái kể**: Hương đèn lao xao  
**Con xô**: Chỗ nào cũng vậy  
**Cái kể**: Tổng làng ai nấy  
**Con xô**: Lập cuộc chơi bời  
**Cái kể**: Thiên hạ thảnh thơi  
**Con xô**: Vui mừng một hội  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: choitrang,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài hát mô tả không khí vui tươi trong đêm rằm Trung thu, với các hoạt động chơi trăng và rước đèn.",
    modernDevelopment:
      "Vẫn được biểu diễn trong các dịp lễ hội Trung thu tại Phú Lễ.",
  },
  {
    id: 2,
    title: "Chúc nghề làm ruộng",
    page: "441-442",
    pageRange: [341, 442],
    pageImages: [page341, page342], // Thêm mảng ảnh trang
    content: `**Cái kể**: Thiên ư tí!  
Địa ư sửu!  
Nhân ư dần!  
Hội tam tài!  
Mới có sanh dân  
Bắt cầm thú ăn tươi uống huyết  
Vua Viêm đế là người thánh triết  
Dạy đẽo cây làm cái cầy bừa  
Trời năm nay thuận gió hòa mưa  
Khai thiên xuống cho dân làm ruộng  
Tôi chúc cho ông có nghề làm ruộng  
**Con xô**: Làm ruộng! Làm ruộng!  
(Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Gặp trời mưa xuống  
**Con xô**: Gieo mạ đã xong  
**Cái kể**: Bắt trâu đực ròng  
**Con xô**: Cày đất cho bã  
**Cái kể**: Kêu công nhổ mạ  
**Con xô**: Lại cấy cho dày  
**Cái kể**: Một bông hai nhánh  
**Con xô**: Hòa muôn triệu triệu  
**Cái kể**: Thử tắc khoan khoan  
**Con xô**: Dư muôn dư ngàn  
**Cái kể**: Bán cho đặng giá  
**Con xô**: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: chucnghelamruong,
    title: "Chúc nghề làm ruộng",
      videoUrl: "https://res.cloudinary.com/dmiuw4ekf/video/upload/v1765267108/chucnghelamruong_hju9ax.mp4",
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài hát chúc mừng nghề nông, cầu mong mùa màng năng suất và phước lộc dồi dào.",
    modernDevelopment:
      "Tiếp tục được hát trong các dịp chúc Tết và lễ hội nông nghiệp tại Phú Lễ.",
  },
  {
    id: 3,
    title: "Chúc nghề làm ruộng 2",
    content: `**Cái kể**: Nhớ thuở xưa chẳng biết cấy cày  
Sống thời ăn những trái cây các loài  
Uống trong đầm nước  
Đồng án tan hoang  
Bà Cửu Thiên xem xét núi sông  
Khuyên vợ chồng ráng mua giống má  
Chỗ giồng cao khai phá nay thấy đất bồi  
Có một bầy trâu ở núi Đông Ngư  
Đưa ngay xuống cho dân làm ruộng  
Ông vua Thần Nông mới độ lượng  
Ngời rạng cho dân đóng cày bừa  
Từ rày thuận gió, thuận mưa  
Cầu thiên đảo xuống cho dân làm ruộng  
(Nghệ nhân đờn cò, trống phách gõ theo)  
**Con xô**: Làm ruộng! Làm ruộng!  
**Cái kể**: Chờ trời mưa xuống  
**Con xô**: Sửa soạn cày bừa  
**Cái kể**: Chờ trời cho mưa  
**Con xô**: Để mà gieo mạ  
**Cái kể**: Gieo thời lúa lạ  
**Con xô**: Thì sạ bốn cây  
**Cái kể**: Thì sạ sáu cây  
**Con xô**: Sạ luôn nửa chục  
**Cái kể**: Gieo rồi để đó  
**Con xô**: Sửa soạn cày bừa  
**Cái kể**: Chờ cho trời mưa  
**Con xô**: Đặng mà phá đất  
**Cái kể**: Xong rồi lật đật  
**Con xô**: Giỡ lật lịch ra  
**Cái kể**: Lựa ngày cho khá  
**Con xô**: Kêu công nhổ mạ  
**Cái kể**: Nhổ tới một ngày  
**Con xô**: Phải đặng tám thiên  
**Cái kể**: Cho cấy xuống liền  
**Con xô**: Lúa ra cuồn cuộn  
**Cái kể**: Lúa đã chín trôi  
**Con xô**: Lúa đà chín rồi  
**Cái kể**: Kêu công mà gặt  
**Con xô**: Gặt luôn một tháng  
**Cái kể**: Để trọn mười ngày  
**Con xô**: Ta mướn xe sang  
**Cái kể**: Về nhà ta đập  
**Con xô**: Gặt luôn một tháng  
**Cái kể**: Tính chẵn mười muôn  
**Con xô**: Chạy tuôn ra chợ  
**Cái kể**: Kêu người mà bán  
**Con xô**: Gặp tá hàng bao  
**Cái kể**: Đặng ta lấy tiền  
**Con xô**: Đặng mà sở phí  
**Cái kể**: Cả nhà tiêu phí  
**Con xô**: Được cả an khương  
**Con xô - Cái kể**: Năm mới giàu sang  
**Con xô - Cái kể**: Gia quan tấn lộc  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: chucnghelamruong2,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài hát thứ hai chúc nghề nông, nhấn mạnh vai trò của Thần Nông và cầu mong vụ mùa năng suất.",
    modernDevelopment:
      "Tiếp tục được trình diễn trong các lễ hội nông nghiệp tại Phú Lễ.",
  },
  {
    id: 4,
    title: "Chúc nghề dệt vải",
    content: `**Cái kể**: Sắc bùa là sắc bùa âu  
Bước qua năm mới, trồng dâu nuôi tằm  
Nuôi tằm lúc mới đầu năm  
Đứa ăn, đứa ngủ, đứa nằm, đứa chơi  
Tôi chúc cho có nghề dệt vải  
**Con xô**: Dệt cửi, tay gửi, tay sang  
(Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Tàn lan bông bắt  
**Con xô**: Dắt mặt xem cơi  
**Cái kể**: Lòng soi suốt chạy  
**Con xô**: Bộng máy, bông may  
**Cái kể**: Bông lài, bông lý  
**Con xô**: Bộng khế, trái xoan  
**Cái kể**: Hồ da, con bướm  
**Con xô**: Cành dương, cây trúc  
**Cái kể**: Hàng bụt, hàng sen  
**Con xô**: Địa đen, nhiễu trắng  
**Cái kể**: Hàng quấn, hàng nho  
**Con xô**: Con cò, con hạc  
**Cái kể**: Bịt bạc, sương sa  
**Con xô**: Xà ba, long ẩn  
**Cái kể**: Long ẩn, long phi  
**Con xô**: Long phi, bát nhạn  
**Cái kể**: Bạn hàng đến tay  
**Con xô**: Giá cả dư ngàn  
**Cái kể**: Làm không kịp đủ  
**Con xô**: Khách chủ phong khê  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: chucnghedetvai,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài hát chúc nghề dệt vải, cầu mong sự phát đạt trong nghề nuôi tằm và dệt lụa.",
    modernDevelopment:
      "Vẫn được biểu diễn trong các dịp chúc Tết tại Phú Lễ, dù nghề dệt truyền thống ít phổ biến hơn.",
  },
  {
    id: 5,
    title: "Chúc nghề thợ đương",
    content: `**Cái kể**: Đầu giồng có một cây duối  
Cuối giồng có một cây da  
Giữa giồng có một ông thợ đương  
Tôi chúc cho có nghề thợ đương  
**Con xô**: Thợ đương! Thợ đương!  
(Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Lông bối, lông sen  
**Con xô**: Rổ sảo lông mốt  
**Cái kể**: Đương thời cũng tốt  
**Con xô**: Đương nia, đương sọt  
**Cái kể**: Đương sáo, đương nong  
**Con xô**: Giồng nào cũng có  
**Cái kể**: Nan thời một bó  
**Con xô**: Đương giỏ, đương gàu  
**Cái kể**: Đương lại làm giàu  
**Con xô**: Người ta năng rước  
**Cái kể**: Bạc vô như nước  
**Con xô**: Tiền chất đầy rương  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: chucnghethoduong,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài hát chúc nghề đan lát, cầu mong sự khéo léo và phát tài trong nghề thợ đương.",
    modernDevelopment:
      "Tiếp tục được trình diễn trong các nghi lễ chúc Tết tại Phú Lễ.",
  },
  {
    id: 6,
    title: "Chúc nghề thợ mộc",
    page: "343",
    pageRange: [343],
    pageImages: [page343], // Thêm mảng ảnh trang
    content: `**Cái kể**: Đời thượng cổ ở hang, nằm nội  
Bị độc sùng thảm hại với người  
Hữu Sà ra đời dạy gác cây cao làm tổ  
Mưa gió lâu năm nó đổ đâu còn, chưa tiện an cư  
Nối sau, Hồ Ngư đẽo kèo cột dạy làm nhà cửa  
Nay cậu mợ làm ăn giàu có  
Mới rước thợ làm nhà  
Tôi chúc cho có nghề thợ mộc  
**Con xô**: Thợ mộc! Thợ mộc!  
(Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Bào xoi, bào móc  
**Con xô**: Đục, bạt, đẽo, khoan  
**Cái kể**: Cưa mỏng, cưa dày  
**Con xô**: Lưỡi rìu, chàng chạm  
**Cái kể**: Đồ mộc sắm đủ  
**Con xô**: Làm cửa, làm nhà  
**Cái kể**: Xe gió, rương sen  
**Con xô**: Giường thờ, trướng ỷ  
**Cái kể**: Cu lơn, trường kỷ  
**Con xô**: Vừa làm ghế xây  
**Cái kể**: Thợ sáng quá tay  
**Con xô**: Người ta năng rước  
**Cái kể**: Bạc vô như nước  
**Con xô**: Tiền chất đầy rương  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: chucnghethomoc,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài hát chúc nghề thợ mộc, ca ngợi sự khéo léo và cầu mong sự thịnh vượng.",
    modernDevelopment: "Vẫn được biểu diễn trong các dịp chúc Tết tại Phú Lễ.",
  },
  {
    id: 7,
    title: "Chúc nghề thợ hồ",
    page: "344-345",
    pageRange: [344, 345],
    pageImages: [page344, page345], // Thêm mảng ảnh trang
    content: `**Cái kể**: Nhớ thuở xưa có bà Cửu Thiên  
Giúp các thợ, thợ nào cũng đặng bình yên  
Chuyên nghề thợ hồ  
Tôi chúc cho có nghề thợ hồ  
**Con xô**: Thợ hồ! Thợ hồ!  
(Nghệ nhân đờn cò, trống phách gõ theo)  
**Cái kể**: Làm nhà phông tô  
**Con xô**: Làm hồ rất tốt  
**Cái kể**: Hồ nhuyễn như bột  
**Con xô**: Bắt chỉ hồi văn  
**Cái kể**: Bàn tay lăng xăng  
**Con xô**: Làm coi thật khéo  
**Cái kể**: Chỉ nào hay méo  
**Con xô**: Sửa lại cho ngay  
**Cái kể**: Sắm đủ bộ bay  
**Con xô**: Đủ đồ chặt gạch  
**Cái kể**: Dồi ghế cẩm thạch  
**Con xô**: Dồi lại tốt thay  
**Cái kể**: Đúc nền thật ngay  
**Con xô**: Trám nền cũng giỏi  
**Cái kể**: Lãnh dãy phố ngói  
**Con xô**: Cậu đúc vách tường  
**Cái kể**: Xây bồn trồng hường  
**Con xô**: Cậu xây cửa cuốn  
**Cái kể**: Cậu xây theo ý muốn  
**Con xô**: Xây thiệt tinh thông  
**Cái kể**: Mướn thợ đủ đông  
**Con xô**: Làm đâu có sổ  
**Cái kể**: Mới lãnh công lệ  
**Con xô**: Mới lãnh phố lầu  
**Cái kể**: Làm thời lâu lâu  
**Con xô**: Chủ kêu uống nước  
**Cái kể**: Làm thợ có phước  
**Con xô**: Làm thợ có phần  
**Cái kể**: Chủ lại ân cần  
**Con xô**: Khen cho có trí  
**Cái kể**: Trí cỡ thầy ký  
**Con xô**: Trí cỡ thầy thông  
**Cái kể**: Sắm chức đầu công  
**Con xô**: Để đi lãnh mối  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: chucnghethoho,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài hát chúc nghề thợ hồ, cầu mong sự khéo léo và thành công trong nghề xây dựng.",
    modernDevelopment:
      "Tiếp tục được trình diễn trong các nghi lễ chúc Tết tại Phú Lễ.",
  },
  {
    id: 8,
    title: "Lý Đầu cầu dài",
    content: `**Cái kể**: Hôm qua anh có qua nhà  
Thấy mẹ nằm võng thấy cha nằm giường  
**Con xô**: Thấy em nằm đất anh thương  
**Cái kể**: Thấy em nằm đất anh thương  
Lộn về kéo gỗ đóng giường tám song  
**Con xô**: Bốn góc anh có bịt vàng  
**Cái kể**: Bốn góc anh có bịt vàng  
Tám song bịt bạc bốn chân chạm rồng  
**Con xô**: Đi đâu bỏ cái phòng không  
**Cái kể**: Đi đâu bỏ cái phòng không  
Để đôi chiếu lạnh bỏ phòng quạnh hiu  
**Con xô**: Trong rừng vượn hú chim kêu  
**Cái kể**: Trong rừng vượn hú chim kêu  
Dưới sông nước chảy, trên đèo thon von  
**Con xô**: Còn trời còn nước còn non  
**Cái kể**: Còn trời còn nước còn non  
Còn cô bán rượu anh còn say sưa  
**Con xô**: Rượu ngon trong nhạo rót ra  
**Cái kể**: Rượu ngon trong nhạo rót ra  
Để lâu nó lạt, lựa là duyên em  
**Con xô**: Tay cầm nhạo rượu chiếc nem  
**Cái kể**: Tay cầm nhạo rượu chiếc nem  
**Con xô**: Say cho quên hết lời em dặn dò  
Cái kể - Con xô: Say cho quên hết lời em dặn dò  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: lydaucaudai,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài lý vui nhộn, kể về tình cảm và cảnh sinh hoạt đời thường, mang tính giải trí.",
    modernDevelopment:
      "Vẫn được trình diễn trong các buổi hát Sắc Bùa tại Phú Lễ.",
  },
  {
    id: 9,
    title: "Lý Lơ thơ",
    page: "355-357",
    pageRange: [355, 356, 357],
    pageImages: [page355, page356, page357], // Thêm mảng ảnh trang
    content: `**Cái kể**: Lơ thơ tơ liễu buông mành  
Con chim oanh oanh mà học nói trên nhành mỉa mai  
(Nghệ nhân đờn cò dạo đầu, cái kể vào nhịp)  
(Vào nhịp) Của này là cậy ai, chiếc xuyến bạc cho thôi mà đeo tay  
Vàng bạc kia cho thôi mà em có  
Để trâm cài là cài cũng không, là mối tóc mai quăn đội khăn sùng  
**Con xô**: Là mối tóc mai quăn đội khăn sùng  
**Cái kể**: Mối tóc mai quăn đội khăn sùng là sùng khăn sùng  
Ba bốn cô cho thôi mà ngồi đó để anh hùng là hùng nhởn nhơ  
Cô này còn nhỏ chưa chồng là ủa chưa chồng  
**Con xô**: Cô này còn nhỏ chưa chồng là ủa chưa chồng  
**Cái kể**: Cô này còn nhỏ chưa chồng là vốn thiệt chưa chồng  
Lợi đây cho tôi mà kết ngãi để làm chồng chồng đặng chăng?  
**Con xô**: Cô về cô nhớ anh chăng?  
**Cái kể**: Cô về cô nhớ anh chăng là anh về cho cái thôi mà anh nhớ để răng á răng, mình cười. Là ba bốn quan chuộc lấy tiếng cười  
**Con xô**: Là ba bốn quan chuộc lấy tiếng cười  
**Cái kể**: Ba bốn quan chuộc lấy tiếng cười chín mười quan cho cái thôi mà không tiếc để tiếc người…  
Cái kể - Con xô: nhan hường nhan, nhan hường nhan  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: lythotho,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài lý vui tươi, mô tả tình cảm lãng mạn và hình ảnh cô gái trẻ.",
    modernDevelopment:
      "Tiếp tục được biểu diễn trong các buổi hát Sắc Bùa tại Phú Lễ.",
  },
  {
    id: 10,
    title: "Lý Đầu cầu vắn",
    content: `**Cái kể**: Đầu cầu kia cất gánh hỏi đầu cầu  
Nâng khăn cái mà đỡ đãi têm trầu ngãi nhân ăn  
(Nghệ nhân đờn cò dạo đầu, cái kể vào nhịp)  
Ngãi nhân ăn là ngãi nhân ơi cậy bấy nhiêu lời  
Giàu thời cho thôi mà giúp của để khó thời, thời giúp công. Một mai sau nên điệu vợ chồng  
**Con xô**: Một mai sau nên điệu vợ chồng  
**Cái kể**: Một mai sau nên điệu vợ chồng, dầu năm cho thôi mà ba tháng để đem lòng, lòng nhớ thương. Nỗi chàng về thiếp càng nhớ nỗi càng thương  
**Con xô**: Nỗi chàng về thiếp càng nhớ nỗi càng thương  
**Cái kể**: Nỗi chàng về thiếp càng nhớ nỗi càng thương. Rạng ngày cho thôi mà sang chiếu để chiếu giường giường sang hơi. Bữa hôm qua mượn áo sang hơi  
**Con xô**: Bữa hôm qua mượn áo sang hơi  
**Cái kể**: Bữa hôm qua mượn áo sang hơi. Rạng ngày cho thôi mà kẻ ngược để người xuôi, xuôi sao đành. Nỗi chàng về thiếp ở sao an  
**Con xô**: Nỗi chàng về thiếp ở sao an  
**Cái kể**: Nỗi chàng về thiếp ở sao an, chàng đi cho thôi mà thiếp cũng để băng ngàn, ngàn thiếp theo. Chim phụng hoàng đậu nhánh cheo leo  
**Con xô**: Chim phụng hoàng đậu nhánh cheo leo  
**Cái kể**: Chim phụng hoàng đậu nhánh cheo leo. Sa cơ cho thôi mà thất thế để lòng theo theo bầy gà. Ếch nhái kêu dưới vũng bồ đa  
**Con xô**: Ếch nhái kêu dưới vũng bồ đa  
**Cái kể**: Ếch nhái kêu dưới vũng bồ đa. Ba bốn cây thôi mà cây khế để mần răng răng khó lừa. Trên sông Mân dưới sông Mẫn sông Đào  
**Con xô**: Trên sông Mân dưới sông Mẫn sông Đào  
**Cái kể**: Trên sông Mân dưới sông Mẫn sông Đào. Ba bốn sông cho thôi mà sông ấy để chảy vào vào sông Ngân. Chùa Quảng Lân cẩn đá chuông đồng  
**Con xô**: Chùa Quảng Lân cẩn đá chuông đồng  
**Cái kể**: Chùa Quảng Lân cẩn đá chuông đồng. Để em qua cho thôi mà một chút để để chồng chồng em sang. Nợ đôi quan trả chín mười quan  
**Con xô**: Nợ đôi quan trả chín mười quan  
**Cái kể**: Nợ đôi quan trả chín mười quan. Chín mười quan cho thôi mà không tiếc để tiếc người, người hường nhan. Trống trên lầu vội đổ tam quan  
Cái kể - Con xô: Trống trên lầu vội đổ tam quan  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: lydaucauvan,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài lý ngắn, kể về tình cảm và lòng thủy chung, với hình ảnh sông và chùa.",
    modernDevelopment:
      "Vẫn được trình diễn trong các buổi hát Sắc Bùa tại Phú Lễ.",
  },
  {
    id: 11,
    title: "Lý Mười hai tháng",
    page: "358-363",
    pageRange: [358, 359, 360, 361, 362, 363],
    pageImages: [page358, page359, page360, page361, page362, page363], // Thêm mảng ảnh trang
    content: `**Cái kể**: Kính thưa cô bác xóm làng  
Chúc xuân mà tôi hát sắc bùa tháng Giêng  
(Nghệ nhân đờn cò dạo đầu, cái kể vào nhịp)  
(vào nhịp) Tháng Giêng chơi Tết năm đầu, thời bao nhiêu mà nho sĩ để đá cầu cầu đánh đu  
**Con xô**: Tháng Hai huê nở năm chu  
**Cái kể**: Tháng Hai huê nở năm chu. Nhạc bồng cho thôi mà trống phách để đền ơn ơn sanh thành  
**Con xô**: Tháng Ba tiết nở đương xuân  
**Cái kể**: Tháng Ba tiết nở đương xuân. Thì gió nam cho thôi mà một trận để hết xuân xuân qua hè  
**Con xô**: Tháng Tư nổi một tiếng ve  
**Cái kể**: Tháng Tư nổi một tiếng ve. Thì ve kêu cho thôi mà khấp khởi để kịp lo lo cấy cày  
**Con xô**: Tháng Năm đêm vắn ngày dài  
**Cái kể**: Tháng Năm đêm vắn ngày dài. Thì đờn ai cho thôi mà thỏ thẻ để bẻ ba ba tiếng kìm  
**Con xô**: Tháng Sáu mưa nổi ruộng chìm  
**Cái kể**: Tháng Sáu mưa nổi ruộng chìm. Chị em cho thôi mà sửa soạn để ra đồng đồng sớm trưa  
**Con xô**: Tháng Bảy ô thước đội cầu  
**Cái kể**: Tháng Bảy ô thước đội cầu. Nhạn về cho thôi mà thấy nhạn để hết sầu sầu Ngưu Lang  
**Con xô**: Tháng Tám lúa trổ vàng tươi  
**Cái kể**: Tháng Tám lúa trổ vàng tươi. Người xem cho thôi mà dưới nước để trên trời trời én đua  
**Con xô**: Tháng Chín lác đác cờ lau  
**Cái kể**: Tháng Chín lác đác cờ lau. Nhạn về cho thôi mà thấy nhạn để bắt cầu cầu sang sông  
**Con xô**: Tháng Mười nước tợ như đồng  
**Cái kể**: Tháng Mười nước tợ như đồng. Già gia cho thôi mà trẻ trẻ để cùng đồng đồng lên cao  
**Con xô**: Mười Một lất phất mưa rào  
**Cái kể**: Tháng Mười Một lất phất mưa rào. Đêm trường cho thôi mà khắc khoải để gió hiu hiu tiết trời  
**Con xô**: Tháng Chạp huê nở khắp nơi  
**Cái kể**: Tháng Chạp huê nở khắp nơi. Chợ huê cho thôi mà chớm chớm để vui cười cười rước xuân  
**Con xô**: Nhà nhà tống cựu nghinh tân  
**Cái kể**: Nhà nhà tống cựu nghinh tân. Đợi thêm cho thôi mà trai gái để rước xuân xuân về nhà  
Cái kể - Con xô: Trâm vàng áo lụa phủ phê. Trâm vàng áo lụa phủ phê  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: ly12thang,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài lý kể về các hoạt động và đặc điểm của 12 tháng trong năm, mang ý nghĩa chúc xuân.",
    modernDevelopment:
      "Tiếp tục được trình diễn trong các dịp Tết và lễ hội tại Phú Lễ.",
  },
  {
    id: 12,
    title: "Vè Cá biển",
    content: `**Cái kể**: Hai bên cô bác,  
Lẳng lặng mà nghe.  
Nghe tôi kể vè,  
Ngư lương, tử hổ.  
Lý sâm, lý chuối,  
Lý rạch, lý ngòi.  
Cá nục, cá úc, cá thơm, cá thác lác,  
Hơi nào mà kể cho hết cá nơi làng này.  
Thần linh chiêm bài  
Vậy mới cất chùa chiền  
Mới đúc Phật, đúc chuông  
Cô bác xóm giềng,  
Lẳng lặng mà nghe:  
**Cái kể**: Cá nuôi thiên hạ  
(Nghệ nhân đờn cò, trống phách gõ theo)  
**Con xô**: Là con cá cơm  
**Cái kể**: Không ăn bằng mồm  
**Con xô**: Là con cá ngác  
**Cái kể**: Không ăn mà ú  
**Con xô**: Là ông cá voi  
**Cái kể**: Hai mắt thòi lòi  
**Con xô**: Là cá trao tráo  
**Cái kể**: Không may quần áo  
**Con xô**: Là con cá chim  
**Cái kể**: May áo không kim  
**Con xô**: Là cá đuối dẻ  
**Cái kể**: Sống lâu mạnh khoẻ  
**Con xô**: Là cá trường sanh  
**Cái kể**: Ở ngoài đầu gành  
**Con xô**: Là cá bống cát  
**Cái kể**: Đi thời xách mác  
**Con xô**: Là con cá dao  
**Cái kể**: Đốn cây mà rào  
**Con xô**: Là con cá chép  
**Cái kể**: Nó kêu óp ép  
**Con xô**: Là con cá heo  
**Cái kể**: Buộc lụa mà treo  
**Con xô**: Là cá cờ phướn  
**Cái kể**: Để lên mà nướng  
**Con xô**: Là cá nóc vàng  
**Cái kể**: Để được hai thoàn  
**Con xô**: Là cá nhám nghệ  
**Cái kể**: Đi thời chậm trễ  
**Con xô**: Là cá lù đù  
**Cái kể**: Đầu óc chù vù  
**Con xô**: Là con cá úc  
**Cái kể**: Bắt lên chặt khúc  
**Con xô**: Là con cá sòng  
**Cái kể**: Vợ đánh với chồng  
**Con xô**: Là con cá sào  
**Cái kể**: Mình cũng như dao  
**Con xô**: Là cá lưỡi trâu  
**Cái kể**: Eo đầu ngắn cổ  
**Con xô**: Là con cá ét  
**Cái kể**: Miệng mồm lép xẹp  
**Con xô**: Là con cá móm  
**Cái kể**: Chơi trăng mà hám  
**Con xô**: Là con cá thu  
**Cái kể**: Vừa sủa vừa tru  
**Con xô**: Là cá hàm chó  
**Cái kể**: May ngồi xỏ rỏ  
**Con xô**: Là cá hàm be  
**Cái kể**: Lắng tai mà nghe  
**Con xô**: Là con cá mỏng  
**Cái kể**: Làm việc cho chóng  
**Con xô**: Là con cá mau  
**Cái kể**: Lãi đãi theo sau  
**Con xô**: Là con cá nóc  
**Cái kể**: Chân đi lốc thốc  
**Con xô**: Là con cá bô  
**Cái kể**: Ăn chẳng hay no  
**Con xô**: Là con cá liệt  
**Cái kể**: Gái tham huê nguyệt  
**Con xô**: Là con cá dâm  
**Cái kể**: Lấy cây mà đâm  
**Con xô**: Là cá nhám nhọn  
**Cái kể**: Nước da lạm xạm  
**Con xô**: Là cá nhám trâu  
**Cái kể**: Mặt trắng làu làu  
**Con xô**: Là cá bạc má  
**Cái kể**: Hình đen như quạ  
**Con xô**: Là cá ô mun  
**Cái kể**: Đặt giữa đình trung  
**Con xô**: Là cá ông sáp  
**Cái kể**: Vừa đi vừa táp  
**Con xô**: Là cá dọ đàng  
**Cái kể**: Kiều lạc khua vang  
**Con xô**: Là con cá ngựa  
**Cái kể**: Rước thầy về chữa  
**Con xô**: Là cá tà ma  
**Cái kể**: Đi xét từ nhà  
**Con xô**: Là con cá sát  
**Cái kể**: Đắp bờ mà tát  
**Con xô**: Là cá ở mương  
**Cái kể**: Giống không biết đường  
**Con xô**: Là con cá lạc  
**Cái kể**: Kể cho cô bác  
**Con xô**: Nghe lấy mà chơi  
Cái kể - Con xô: Kể đã hết hơi  
Cái kể - Con xô: Kể đã hết hơi  
Cái kể - Con xô: Xin cho tôi nghỉ  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: vecabien,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài vè vui nhộn liệt kê các loài cá biển, mang tính giải trí và gắn với đời sống ngư dân.",
    modernDevelopment:
      "Vẫn được trình diễn trong các buổi hát Sắc Bùa tại Phú Lễ.",
  },
  {
    id: 13,
    title: "Vè Cá đồng",
    content: `**Cái kể**: Trước hết là câu đàn câu cắm  
Sau đăng đó lợp lờ  
Kể thông cùng tóm tắt sơ sơ  
Thử con cá đồng có mấy thứ  
**Cái kể**: Cá ăn không cữ  
(Nghệ nhân đờn cò, trống phách gõ theo)  
**Con xô**: Là cá trê leo  
**Cái kể**: Ăn cám ăn bèo  
**Con xô**: Là con cá sặc  
**Cái kể**: Gai chông gút mắc  
**Con xô**: Là con cá rô  
**Cái kể**: Đóng bọt ra vô  
**Con xô**: Cá lia thia trống  
**Cái kể**: Tuổi cao tác trọng  
**Con xô**: Là cá bạc đầu  
**Cái kể**: Nhỏ tác có râu  
**Con xô**: Là con cá chốt  
**Cái kể**: Xem coi tướng tốt  
**Con xô**: Là con cá chài  
**Cái kể**: Nối đuôi đi hoài  
**Con xô**: Là cá lạc mạ  
**Cái kể**: Hình xem cũng lạ  
**Con xô**: Là cá lóc bông  
**Cái kể**: Tánh hay ở bùn  
**Con xô**: Là con cá chạch  
**Cái kể**: Ăn bèo lách chách  
**Con xô**: Là con cá linh  
**Cái kể**: Da thịt trắng tinh  
**Con xô**: Là cá thác lác  
**Cái kể**: Ăn bùn ăn cát  
**Con xô**: Là cá bống kèo  
**Cái kể**: Ăn cực ăn nghèo  
**Con xô**: Là con cá cháo  
**Cái kể**: Mưa sa rộ rạo  
**Con xô**: Là cá lài bai  
**Cái kể**: Thịt nó hơi dai  
**Con xô**: Là cá trê trắng  
**Cái kể**: Lấy nước cho sẵn  
**Con xô**: Là cá ròng ròng  
**Cái kể**: Ăn học chí công  
**Con xô**: Là con cá đối  
**Cái kể**: Đầu nhọn hay nổi  
**Con xô**: Là con cá kiềm  
**Cái kể**: Ăn nói chẳng nghiêm  
**Con xô**: Là con cá nhái  
**Cái kể**: Miệng mồm dơ dáy  
**Con xô**: Là cá bả trầu  
**Cái kể**: Lặn lội hồi lâu  
**Con xô**: Là con cá lóc  
**Cái kể**: Kết duyên tơ tóc  
**Con xô**: Là cá trê dừa  
Cái kể - Con xô: Thịt nó người ưa  
Cái kể - Con xô: Thịt nó người ưa  
Cái kể - Con xô: Là cá trê mỡ  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: vecadong,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài vè liệt kê các loài cá đồng, mang tính giải trí và gắn với đời sống nông thôn.",
    modernDevelopment:
      "Tiếp tục được trình diễn trong các buổi hát Sắc Bùa tại Phú Lễ.",
  },
  {
    id: 14,
    title: "Vè Con tôm",
    content: `**Cái kể**: Bây giờ tôi trở  
**Con xô**: Lại các thứ tôm  
**Cái kể**: Đầu lớn chôm bôm  
**Con xô**: Là con tôm tích  
**Cái kể**: Bắt người ăn thịt  
**Con xô**: Là con tôm hùm  
**Cái kể**: Ở bụi, ở lùm  
**Con xô**: Là con tôm cỏ  
**Cái kể**: Bắt bỏ vào giỏ  
**Con xô**: Là con tôm lươn  
**Cái kể**: Gánh đất lấp đường  
**Con xô**: Là con tôm đất  
**Cái kể**: Vô chùa lạy Phật  
**Con xô**: Là con tôm tu  
**Cái kể**: Sóng đánh chổng khu  
**Con xô**: Là con tôm cồn  
**Cái kể**: Nấu cơm sồn sồn  
**Con xô**: Là con tôm gạo  
**Cái kể**: Máy nước thơm thảo  
**Con xô**: Là con tôm trăm  
**Cái kể**: Bịt chén bịt mâm  
**Con xô**: Là con tôm bạc  
**Cái kể**: Phải quấy cũng gạt  
**Con xô**: Là con tôm càng  
**Cái kể**: Rèn đục rèn chàng  
**Con xô**: Là con tôm sắc  
**Cái kể**: Hay cắn hay ngắt  
**Con xô**: Là con tôm chong  
**Cái kể**: Nghe bậu lấy chồng  
**Con xô**: Là con tôm lóng  
**Cái kể**: Lấy chồng cho chóng  
**Con xô**: Là con tôm gian  
**Cái kể**: Da thịt nó vàng  
**Con xô**: Là con tôm nghệ  
**Cái kể**: Việc làm bê trễ  
**Con xô**: Là con tôm te  
Cái kể - Con xô: Kể đã đủ vè  
Cái kể - Con xô: Kể đã đủ vè  
Cái kể - Con xô: Xin cho tôi nghỉ  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: vecontom,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài vè vui nhộn liệt kê các loại tôm, mang tính giải trí và gắn với đời sống sông nước.",
    modernDevelopment:
      "Vẫn được trình diễn trong các buổi hát Sắc Bùa tại Phú Lễ.",
  },
  {
    id: 15,
    title: "Vè Kỷ niệm năm thứ ba mươi",
    content: `**Cái kể**: Năm ba mươi là năm ra đời  
Việt Minh đứng vậy cơ trời đổi thay  
**Con xô**: Trước là Nhật đảo chánh Tây  
**Cái kể**: Cộng hòa dân chủ trước đây cụ Hồ  
**Con xô**: Ông Hồ quê quán ngoài kinh đô  
**Cái kể**: Quyết lòng đem lại cơ đồ Việt Nam  
**Con xô**: Tính rồi ông mới ra đi  
**Cái kể**: Nay là Chủ tịch tại trào ngôi cao  
Tính rồi ông cầu khắp ngoại giao  
**Cái kể**: Gầy đoàn kết quả: Pháp trào ông đuổi ra  
**Con xô**: Nói qua Trung, Bắc với Nam ta  
**Cái kể**: Gầy đàn liên hiệp thật là tài thay  
**Con xô**: Nhờ ơn anh chiến sĩ anh tài  
**Cái kể**: Tự do hạnh phúc mới có ngày an khương  
**Con xô**: Khá khen anh chiến sĩ hùng cường  
**Cái kể**: Dầm sương chẳng ngại chịu đường lao đao  
**Con xô**: Ngày nay xoay đổi phong trào  
**Cái kể**: Dẫu cho thịt nát dạ nào dám sai  
**Con xô**: Tám mươi năm mắc phải đọa đày  
**Cái kể**: Làm thân nô lệ, ngày ngày ngóng trông  
**Con xô**: Ngày nay chim đặng sổ lồng  
**Cái kể**: Cá kia khỏi chậu mặc lòng đua bơi  
**Con xô**: Xưa nay sinh bất phùng thời  
**Cái kể**: Ngày nay nghĩ lại hết đời trầm luân  
**Con xô**: Bao giờ Nam Việt phục hưng  
**Cái kể**: Anh em ta sẽ hết đường gian lao  
**Con xô**: Chúc cho cả thảy các đàng  
**Cái kể**: Bình an vô sự hiển vang trăm phần  
**Con xô**: Vái trời trổ đặng điềm lân  
**Cái kể**: Nam kỳ phụng gáy, gió tày bặt giông  
**Con xô**: Từ rày bật ngọn Đông phong  
**Cái kể**: Cao trào tiếp Bắc đuổi loài thực dân  
**Con xô**: Đuổi ra cho khỏi thôn lân  
**Cái kể**: Đuổi ra cho khỏi biên cương cõi ngoài  
**Con xô**: Rồi Nam, Trung, Bắc đặng lâu dài  
**Cái kể**: Chúc cho bốn chữ thạnh tài vô cương  
**Con xô**: Chúc cho vạn đại vô cương  
**Cái kể**: Bình quyền nam nữ đường đường khắp nơi  
**Con xô**: Bao giờ gặp cuộc thảnh thơi  
Cái kể - Con xô: Giá vô bể hổ đời đời an khương  
Cái kể - Con xô: Giá vô bể hổ đời đời an khương  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ. Bài hát kỷ niệm 30 năm Cách mạng tháng Tám (1945-1975).`,
    image: namthubamuoi,
    year: "1975",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài vè kỷ niệm 30 năm Cách mạng tháng Tám (1945-1975), ca ngợi sự đoàn kết và độc lập dân tộc.",
    modernDevelopment:
      "Được trình diễn trong các dịp kỷ niệm lịch sử tại Phú Lễ.",
  },
  {
    id: 16,
    title: "Vè Cạo muối",
    content: `**Cái kể**: Nhớ thuở trước ông bà làm phước  
Sanh con cháu ra, lăn lóc cũng nhiều  
Ruộng nương đà có bấy nhiêu  
Chân nước mặn mới bị phèn làm chết lúa  
Công cực khổ, mần ra có của  
Tháng Giêng, tháng Hai, đất nẻ khô đồng  
Trời không mưa, nước kém, không rong  
Muối xủi vun vun như đất bủn  
Anh em điều cũng cộ pháp ra biền  
Ra rừng gánh củi, quơ chà  
Đập miểng gáo bày ra cạo đất  
**Con xô**: Cạo đất, cạo đất  
**Cái kể**: Hừng đông lật đật  
**Con xô**: Quảy gióng, gánh thùng  
**Cái kể**: Cạo muối đất bùn  
**Con xô**: Quẩy hầm lấy nước  
**Cái kể**: Người nào tính trước  
**Con xô**: Mần củi trong năm  
**Cái kể**: Rừng có kiểm lâm  
**Con xô**: Khó thôi vô số  
**Cái kể**: Anh em chiếu cố  
**Con xô**: Chịu cực làm ăn  
**Cái kể**: Quan trên họ răn  
**Con xô**: Mình đừng xao xuyến  
**Cái kể**: Mình đừng làm biếng  
**Con xô**: Cứ việc quơ chà  
**Cái kể**: Bắt đầu tháng ba  
**Con xô**: Mưa giông thì nghỉ  
**Cái kể**: Vợ chồng thủ thỉ  
**Con xô**: Thầm tiếng nhỏ to  
**Cái kể**: Ăn cơm cho no  
**Con xô**: Hừng đông đi sớm  
**Cái kể**: Mần thôi lực đởm  
**Con xô**: Gánh nước cho nhiều  
**Cái kể**: Lửa cháy liu riu  
**Con xô**: Bẻ chà chụm lửa  
**Cái kể**: Nằm vật, nằm vựa  
**Con xô**: Lấy muối huyên thuyên  
**Cái kể**: Mình chằng năm yên  
**Con xô**: Giật mình thức dậy  
**Cái kể**: Lo bề họ lấy  
**Con xô**: Muối mắc thất kinh  
**Cái kể**: Một đồng, một giạ  
**Con xô**: Anh em đều cả  
**Cái kể**: Nở mặt, nở gan  
Cái kể - Con xô: Năm mới giàu sang  
Cái kể - Con xô: Gia quan tấn lộc  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: vecaomuoi,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài vè mô tả nghề cạo muối, ca ngợi sự chăm chỉ và cầu mong sự phát đạt.",
    modernDevelopment:
      "Vẫn được trình diễn trong các buổi hát Sắc Bùa tại Phú Lễ, dù nghề cạo muối ít phổ biến hơn.",
  },
  {
    id: 17,
    title: "Lý Ba - Bảy - Hai mươi mốt",
    content: `**Cái kể**: Mười một vú hãy còn son  
Mười hai vú dậy, vú tròn như vung  
Mười ba thiếp mới lấy chồng  
**Con xô**: Là ba mười ba thiếp mới lấy chồng  
**Cái kể**: Mười ba thiếp mới lấy chồng  
Bước qua mười bốn trong lòng thọ thai  
Mười lăm thiếp đẻ con trai  
**Con xô**: Là lăm, mười lăm thiếp đẻ con trai  
**Cái kể**: Mười lăm thiếp đẻ con trai  
Bước qua mười sáu được hai đời chồng  
Mười bảy thiếp nằm phòng không  
**Con xô**: Là bảy mười bảy thiếp nằm phòng không  
**Cái kể**: Mười lăm thiếp đẻ con trai  
Bước qua mười tám lấy chồng Quảng Xuyên  
Mười chín lấy thợ đóng thuyền  
**Con xô**: Là chín mười chín lấy thợ đóng thuyền  
**Cái kể**: Mười chín lấy thợ đóng thuyền  
Hai mươi lấy lính xuống thuyền chèo đua  
Hai mốt lấy thợ câu cua  
**Con xô**: Là mốt hai mốt lấy thợ câu cua  
**Cái kể**: Hai mốt lấy thợ câu cua  
Hai hai vô chùa lấy hết thầy tu  
Hai ba lấy thợ đóng dù  
**Con xô**: Là ba hai mươi ba lấy thợ đóng dù  
**Cái kể**: Hai ba lấy thợ đóng dù  
Bước qua hai bốn lấy Thu trong làng  
Hai lăm thiếp lấy chồng quan  
**Con xô**: Là lăm hai mươi lăm thiếp lấy chồng quan  
**Cái kể**: Hai lăm thiếp lấy chồng quan  
Bước qua hai sáu lên thàng về cha  
Cái kể - Con xô: Bước qua hai sáu lên thàng về cha  

**Mốc thời gian**: Được ghi nhận trong cuộc khảo sát năm 1998 về các bài hát Sắc Bùa Phú Lễ.`,
    image: a3721,
    year: "Truyền thống",
    type: "Giúp vui",
    icon: "🎶",
    description:
      "Bài lý vui nhộn, kể về hành trình hôn nhân của một cô gái qua các độ tuổi, mang tính giải trí.",
    modernDevelopment:
      "Vẫn được trình diễn trong các buổi hát Sắc Bùa tại Phú Lễ.",
  },
];

export default giupVuiData;
